module.exports = __webpack_public_path__ + "static/media/photo250.4b2c7043.jpg";